import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import reportWebVitals from './reportWebVitals';
import storageManager from './utils/storageManager';

// Global error handler for localStorage quota issues
window.addEventListener('error', (event) => {
  if (event.error && event.error.name === 'QuotaExceededError') {
    console.warn('localStorage quota exceeded detected');
    storageManager.showQuotaExceededMessage();
  }
});

// Also catch unhandled promise rejections
window.addEventListener('unhandledrejection', (event) => {
  if (event.reason && event.reason.name === 'QuotaExceededError') {
    console.warn('localStorage quota exceeded detected in promise');
    storageManager.showQuotaExceededMessage();
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // Temporarily disabled StrictMode to resolve property redefinition errors
  // <React.StrictMode>
    <App />
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
